<div class="container-fluid">
    <div class="d-flex justify-content-between p-1">
        <h6>Liste des enseignants</h6>
        <div class="d-flex">
            <select class="mx-1" id="" (change)="changeView($event)">
                <option value="list">vue liste</option>
                <option value="photo">vue photo</option>
            </select>
            <select class="mx-1" id="" (change)="loadlist($event)">
                <option disabled selected></option>
                <option *ngFor="let c of classrooms" [value]="c.id">{{c.name}}</option>
            </select>
        </div>
    </div>

    <app-professor-list [vue]="vue" [data]="data"></app-professor-list>
</div>